var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"customer-item"},[_c('a',{staticClass:"customer-thumbnail",attrs:{"href":_vm.item.link}},[_c('img',{attrs:{"src":_vm.item.image_url}})]),_c('figcaption',{staticClass:"customer-caption"},[_c('h4',{staticClass:"customer-title"},[_c('a',{attrs:{"href":_vm.item.link}},[_vm._v(_vm._s(_vm.item.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }